
<main-form-modal (toggleChange)="setVal($event)"> 
    <ng-template #customHtmlElements>
        <div [ngSwitch]="editMode">
           
            <honors-set-edit *ngSwitchCase="true"></honors-set-edit>
            <honors-set-details *ngSwitchCase="false"></honors-set-details>
        </div>
    </ng-template>  
</main-form-modal>